// test2769
(2769 && 0);
